// extracted by mini-css-extract-plugin
export default {"chip":"Chip_chip__O7FRT","reklama":"Chip_reklama__DhGGD","akcija":"Chip_akcija__M7TVn","pryvitannia":"Chip_pryvitannia__mJXbw"};